<template>
    <w-flex class="justify-end">
        <template v-if="max > 10000000000">
            <div class="box ml1 z-pagination-text">
                <w-select
                    v-if="path"
                    label="Lompat"
                    label-position="left"
                    :items="pages"
                    class="box"
                    v-model="page"
                />
            </div>
        </template>
        <template v-else>
            <inertia-link
                v-for="(link, idx) in links"
                :key="idx"
                text
                md
                class="ml1 box z-pagination-text"
                v-html="link.label"
                preserve-state
                @click="loadpg(link.label)"
            ></inertia-link>
        </template>
    </w-flex>
</template>

<script>
export default {
    name: "pagination",
    props: {
        from: {
            type: Number,
            default: 1,
        },
        to: {
            type: Number,
            default: 10,
        },
        max: {
            type: Number,
            default: 10,
        },
        current: {
            type: Number,
            default: 1,
        },

        last_page: {
            type: Number,
            default: 1,
        },
        showGoto: {
            type: Boolean,
            default: true,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        path: String,
        links: [Object, Array],
    },
    data() {
        return {
            page: this.current,
            last_page: this.last_page,
        };
    },
    computed: {
        hasToolBarButton() {
            return !!this.$slots.buttons;
        },
        pages() {
            const res = [...Array(this.max)].map((_, i) => {
                return { label: i + 1, value: i + 1 };
            });
            return res;
        },
    },
    methods: {
        loadpg(page) {
            this.$emit("loading", true);
            if (page == "&laquo; " || page == "&laquo; Previous") {
                if (this.page == 1) {
                    page = this.page;
                } else {
                    page = this.page - 1;
                }
            } else if (page == " &raquo;" || page == "Next &raquo;") {
                if (this.last_page == this.page) {
                    page = this.page;
                } else {
                    page = this.page + 1;
                }
            }

            // this.$inertia.visit(this.path + '?page='+this.page +'&per_page=' + this.perPage, { preserveScroll: true })
            var url = this.$page.url.replace(window.location.search, "");
            if (window.location.search) {
                url = url + "" + window.location.search;
                url = url.replace("&page=" + this.page, "");
                url = url.replace("?page=" + this.page, "?");
                url = url.replace("?&", "?");
                url = url + "&page=" + this.page;
            } else {
                url = url + "?page=" + this.page;
            }
            url = url.replace("page=" + this.page, "page=" + page);
            url = url.replace("&per_page=" + this.perPage, "");
            url = url.replace("?per_page=" + this.perPage, "");
            url = url.replace("?&", "?");
            url = url.replace("&per_page=undefined" , "");
            url = url.replace("page=undefined", "page=10");
            url = url.replace("per_page=undefined", "per_page=10");
            this.$inertia.visit(url, { preserveScroll: true });
        },
    },
    watch: {
        current: function (val) {
            this.page = val;
        },
        page: function (val) {
            this.$emit("pageChanged", val);
        },
        perPage: function (val, oldval) {
            // if(val != oldval) {
            //   console.log(val, oldval)
            //   // this.loadpg()
            // }
        },
    },
};
</script>

<style>
.table-bar-search-bottom {
    padding: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
</style>
